import { render, staticRenderFns } from "./c-upload-image.vue?vue&type=template&id=3b36e94e&"
import script from "./c-upload-image.vue?vue&type=script&lang=js&"
export * from "./c-upload-image.vue?vue&type=script&lang=js&"
import style0 from "./c-upload-image.vue?vue&type=style&index=0&id=3b36e94e&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports